import { httpClient } from '@/services/http/client'
import { buildApiUrl, ApiService } from '@/config/api.config'
import type { ResidentialComplex } from '@/types/entities/residential-complex'
import type { Article } from '@/types/entities/article'

/**
 * API методы для Home feature
 */
export const homeApi = {
  /**
   * Получить избранные жилые комплексы
   * Использует POST запрос с фильтром featured: true
   */
  async getFeaturedComplexes(): Promise<ResidentialComplex[]> {
    const url = buildApiUrl(ApiService.Properties, 'properties/residential-complexes')
    const response = await httpClient.post<{ residentialComplexes: ResidentialComplex[] }>(url, {
      filter: {
        featured: 1, // RESIDENTIAL_COMPLEX_FEATURED_FILTER_TRUE
      },
      pagination: {
        page: 1,
        perPage: 10, // Достаточно для карусели
      },
    })
    return response.residentialComplexes || []
  },

  /**
   * Получить избранные статьи
   */
  async getFeaturedArticles(): Promise<Article[]> {
    const url = buildApiUrl(ApiService.Articles, 'articles/featured')
    const response = await httpClient.get<{ articles: Article[] }>(url)
    return response.articles || []
  },
}
